import React from 'react';
import PropTypes from 'prop-types';
import ConstituentPropType from '@/lib/types/ConstituentPropType';
import PopoverMenuType from '../constants/PopoverMenuType';
import ConstituentCommunicationMenu from './ConstituentCommunicationMenu';
import ConstituentInteractionMenu from './ConstituentInteractionMenu';

function ConstituentPopover({ type, ...rest }) {
  return type === PopoverMenuType.OTHER ? (
    <ConstituentInteractionMenu {...rest} />
  ) : (
    <ConstituentCommunicationMenu
      isEmail={type === PopoverMenuType.EMAIL}
      {...rest}
    />
  );
}

ConstituentPopover.propTypes = {
  constituent: ConstituentPropType,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  target: PropTypes.element,
  type: PropTypes.oneOf(Object.values(PopoverMenuType)),
};

ConstituentPopover.defaultProps = {
  constituent: null,
  onClose: () => {},
  open: false,
  target: null,
  type: null,
};

export default ConstituentPopover;
